export default "__VITE_ASSET__DkMD6HHN__"